// extracted by mini-css-extract-plugin
module.exports = {"ServicesHome":"services-legacy_ServicesHome__kq7ab"};